export const COMPLETION_CHANGE_WORKPACKAGE_STATUS_BEGIN = 'COMPLETION_CHANGE_WORKPACKAGE_STATUS_BEGIN';
export const COMPLETION_CHANGE_WORKPACKAGE_STATUS_SUCCESS = 'COMPLETION_CHANGE_WORKPACKAGE_STATUS_SUCCESS';
export const COMPLETION_CHANGE_WORKPACKAGE_STATUS_FAILURE = 'COMPLETION_CHANGE_WORKPACKAGE_STATUS_FAILURE';
export const COMPLETION_CHANGE_WORKPACKAGE_STATUS_DISMISS_ERROR = 'COMPLETION_CHANGE_WORKPACKAGE_STATUS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/completion/redux/constants.js